import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";
import { ApplyInputTypeInfo, SubscribeInfoData } from "./agent-user-subinfo-get";
import { isAgentAvailableForUser } from "@/utils/agent-availability";

// 原始接口
interface AgentResponse {
  agents: Agent[];
  total: number;
  current_page: number;
  page_size: number;
  total_pages: number;
}
export interface Agent {
  id: string;
  name: string;
  avatar: string;
  intro: string;
  creator_id: string;
  created_at: string;
  updated_at: string;
};

// 请求接口
interface AgentListRequest {
  page?: number;
  pageSize?: number;
}

export class AgentData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Avatar cannot be empty")
  @IsString("Avatar must be a string")
  avatar: string;

  @Required("Intro cannot be empty")
  @IsString("Intro must be a string")
  intro: string;

  // @Required("SubDomain cannot be empty")
  @IsString("SubDomain must be a string")
  subDomain: string;

  @IsNumber("enableStatus must be a number")
  enableStatus: number;

  @IsNumber("manageStatus must be a number")
  manageStatus: number;

  @IsNumber("status must be a number")
  status: number;

  @IsString("creatorName must be a string")
  creatorName: string;

  @IsNumber("status must be a number")
  expireAt?: number;

  @IsString("subName must be a string")
  subName?: string;

  @IsString("subIntro must be a string")
  subIntro?: string;

  @IsString("subIntroduction must be a string")
  subIntroduction?: string;

  @IsString("subAvatar must be a string")
  subAvatar?: string;

  @Required("Subscribe info cannot be empty")
  @ValidateNested(SubscribeInfoData)
  subscribeInfo?: SubscribeInfoData;

  @Required("Apply input type info cannot be empty")
  @ValidateNested(ApplyInputTypeInfo)
  applyInputTypeInfo?: ApplyInputTypeInfo;

  @Required("Push settings cannot be empty")
  pushSettings?: { [key: number]: number };

  /** 是否可用智能体：智能体（status）打开 && (用户订阅（enable_status）打开 || 用户权限（manage_status）打开) */
  availableAgent?: boolean;

  @IsNumber("agentExpiresAt must be a number")
  agentExpiresAt?: number;
}

export class AgentListData {
  @IsArray("Agents must be an array")
  agents: AgentData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Current page cannot be empty")
  @IsNumber("Current page must be a number")
  currentPage: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;

  @Required("Total pages cannot be empty")
  @IsNumber("Total pages must be a number")
  totalPages: number;
}

const transformAndValidateAgent = (
  response: AgentResponse
): AgentListData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentListData);
    if (data.agents?.length) {
      data.agents.forEach((item) => {
        item.availableAgent = isAgentAvailableForUser(item);
      });
    }
    console.log("agent list data:", data?.agents);
    return data;
  } catch (error) {
    console.error("Agent data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 列表 */
export const agentList = async ({ page, pageSize }: AgentListRequest): Promise<AgentListData> => {
  const response = await api.post<AgentResponse>('/agent/list', {
    page,
    page_size: pageSize,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
